/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateClassRoomRequest
 */
export interface CreateClassRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateClassRoomRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClassRoomRequest
     */
    description: string | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateClassRoomRequest
     */
    locationId: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the CreateClassRoomRequest interface.
 */
export function instanceOfCreateClassRoomRequest(value: object): value is CreateClassRoomRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    return true;
}

export function CreateClassRoomRequestFromJSON(json: any): CreateClassRoomRequest {
    return CreateClassRoomRequestFromJSONTyped(json, false);
}

export function CreateClassRoomRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClassRoomRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'locationId': ApiUserTasksGetPageParameterFromJSON(json['locationId']),
    };
}

export function CreateClassRoomRequestToJSON(json: any): CreateClassRoomRequest {
    return CreateClassRoomRequestToJSONTyped(json, false);
}

export function CreateClassRoomRequestToJSONTyped(value?: CreateClassRoomRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'locationId': ApiUserTasksGetPageParameterToJSON(value['locationId']),
    };
}

